import PhoneBoothScreen from 'components/PhoneBoothScreen';
import PhoneHandle from 'components/PhoneHandle';
import useIsMobileLayout from 'hooks/useIsMobileLayout';
import { useScreenSizeRatio } from 'hooks/useScreenSizeRatio';
import React from 'react';
import { useAppDispatch } from 'state/hooks';
import { usePhoneboothState } from 'state/phonebooth/hooks';
import { updatePhoneboothState } from 'state/phonebooth/slice';
import { useTransmission01 } from 'state/sounds/hooks';

import * as S from './Home.styles';

const ScreenHandler: React.FC<{ backgroundRatio: number }> = () => {
  const dispatch = useAppDispatch();
  const screenState = usePhoneboothState();
  const transmission01 = useTransmission01();

  const isMobileLayout = useIsMobileLayout();

  const backgroundRatio = useScreenSizeRatio();

  return (
    <S.PhoneScreenWrapper sizeRatio={backgroundRatio}>
      {!isMobileLayout && <S.BackgroundLightOff sizeRatio={backgroundRatio} />}
      <S.BackgroundLightOn sizeRatio={backgroundRatio} />
      <PhoneBoothScreen transmission={transmission01} />
      {screenState === 'receiveTransmission' && (
        <PhoneHandle
          onHandleClicked={() => {
            if (screenState === 'receiveTransmission') {
              dispatch(updatePhoneboothState('transmitting'));
              transmission01.play();
            }
          }}
        />
      )}
    </S.PhoneScreenWrapper>
  );
};

export default ScreenHandler;
